import { SecureConfirmationModal as UIKitSecureConfirmationModal } from "@/react/components/shared/ModalsV2/SecureConfirmationModal";
import type { SecureConfirmationModalProps } from "@/react/components/shared/ModalsV2/SecureConfirmationModal";
import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { CompassSecureConfirmationModal } from "./CompassSecureConfirmationModal";

// eslint-disable-next-line no-barrel-files/no-barrel-files -- This is a compatibility layer that re-exports types for SettingsApp
export type { SecureConfirmationModalProps };

export const SecureConfirmationModal = (
  props: SecureConfirmationModalProps,
) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");

  if (isCircleV4) {
    return <CompassSecureConfirmationModal {...props} />;
  }

  return <UIKitSecureConfirmationModal {...props} />;
};
